import React from 'react';

export interface BenefitProps {
  Icon: React.FC<{ width: number; className: string }>;
  description: string;
}

const Benefit = ({ Icon, description }: BenefitProps) => {
  return (
    <div className="mt-48 flex flex-col items-center sm:mt-32 sm:flex-row">
      <Icon width={50} className="w-[50px] shrink-0 sm:w-40" />
      <div className="mt-16 text-center font-suisse-screen text-headline-alt-sm font-medium sm:ml-32 sm:mt-0 sm:text-left">
        {description}
      </div>
    </div>
  );
};

export default Benefit;
